import styled from '@emotion/styled';
import { Medium, SemiBold } from '@src/apps/styles/common-style';

export const BannerStyle = styled.div`
  .release-text {
    z-index: 1001;
    position: sticky;
    height: 38px;
    width: 100%;
    top: 0;
  }
  .release-notes-text {
    background: #e3f0fd;
    height: 38px;
    font-family: ${Medium};
    color: #2d2d39;
    font-size: 14px;
    padding: 0 14px 0 12px;
    line-height: 38px;
    justify-content: space-between;
    display: flex;
  }

  .release-icon {
    height: 24px;
    width: 18px;
    line-height: 30px;
    vertical-align: middle;
    padding-right: 2px;
    display: inline-flex;
  }

  .release-notes-text-left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .view-release {
    padding-left: 4px;
    cursor: pointer;
    color: #196ecf;
    text-align: right;
    font-family: ${SemiBold};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 128.571% */
    letter-spacing: 0.2px;

    .icon-align {
      vertical-align: middle;
      height: 25px;
      width: 25px;
    }
  }

  .second-link {
    padding-left: 0;
  }

  .link-divider {
    color: #757588;
    padding: 0 4px;
  }

  .release-notes-text-right {
    .close-icon {
      height: 24px;
      width: 24px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      border: none;
      background: transparent;
      cursor: pointer;
      line-height: 38px;
      vertical-align: middle;
      position: relative;
      top: 2px;
      right: 6px;
    }
  }
`;
